import { errorToaster } from "../helpers/toasterConfiguration";

const ERRORS_OBJECT = {
  400: "400Error",
  401: "401Error",
  403: "403Error",
  404: "404Error",
  500: "500Error",
};

export const handleError = (error) => {
  if (error && error?.status === 401) {
    window.location.replace("/login");
  }
  if (error && error?.status === 403) {
    window.location.replace("/");
  }
  //  else errorToaster(error?.data?.Message || ERRORS_OBJECT[error?.status]);

  // errorToaster(error?.data?.Message || ERRORS_OBJECT[error?.status]);
};
